import {
  ExtendedDataHelper,
  InformationType,
  InfoTypeHelper,
  POPULATION_TYPE,
} from "@/common/models";

import { isEmpty, isNotEmpty, sortBy } from "@/fp";
import { CountResult, UniqusResult } from "./lib";

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};

//#region  NEW STUFF

export enum RiskScoreType {
  Insight = "Insight",
  Total = "Total",
  TotalCritical = "TotalCritical",
  OverExposure = "OverExposure",
  OverExposureCritical = "OverExposureCritical",
  OverSharing = "OverSharing",
  OverSharingCritical = "OverSharingCritical",
  UnsecureSharing = "UnsecureSharing",
  UnsecureSharingCritical = "UnsecureSharingCritical",
  LackOfLabeling = "LackOfLabeling",
  LackOfLabelingCritical = "LackOfLabelingCritical",
  Total_information_sharing = "Total_information_sharing",
  HR_information_sharing = "HR_information_sharing",
  Legal_information_sharing = "Legal_information_sharing",
  Financial_information_sharing = "Financial_information_sharing",
  Governance_information_sharing = "Governance_information_sharing",
  Business_information_sharing = "Business_information_sharing",
  Other_information_sharing = "Other_information_sharing",
  Total_Access = "Total_Access",
  HR_Access = "HR_Access",
  Legal_Access = "Legal_Access",
  Financial_Access = "Financial_Access",
  Governance_Access = "Governance_Access",
  Business_Access = "Business_Access",
  Other_Access = "Other_Access",
  Total_Information_Governance = "Total_Information_Governance",
  HR_Information_Governance = "HR_Information_Governance",
  Legal_Information_Governance = "Legal_Information_Governance",
  Financial_Information_Governance = "Financial_Information_Governance",
  Governance_Information_Governance = "Governance_Information_Governance",
  Business_Information_Governance = "Business_Information_Governance",
  Other_Information_Governance = "Other_Information_Governance",
  Total_exposure = "Total_exposure",
  HR_exposure = "HR_exposure",
  Legal_exposure = "Legal_exposure",
  Financial_exposure = "Financial_exposure",
  Governance_exposure = "Governance_exposure",
  Business_exposure = "Business_exposure",
  Other_exposure = "Other_exposure",
  Total_stolen = "Total_stolen",
  HR_stolen = "HR_stolen",
  Legal_stolen = "Legal_stolen",
  Financial_stolen = "Financial_stolen",
  Governance_stolen = "Governance_stolen",
  Business_stolen = "Business_stolen",
  Other_stolen = "Other_stolen",
  Total_loss = "Total_loss",
  HR_loss = "HR_loss",
  Legal_loss = "Legal_loss",
  Financial_loss = "Financial_loss",
  Governance_loss = "Governance_loss",
  Business_loss = "Business_loss",
  Other_loss = "Other_loss",
  Total_breach = "Total_breach",
  HR_breach = "HR_breach",
  Legal_breach = "Legal_breach",
  Financial_breach = "Financial_breach",
  Governance_breach = "Governance_breach",
  Business_breach = "Business_breach",
  Other_breach = "Other_breach",
}

interface TrendTimeFrames {
  type: TimeAxisType;
  date: string;
  points_count: number;
}

export interface RiskTypeScoreParams {
  type: RiskScoreType;
  timeFrames: TrendTimeFrames;
  employeeId: string;
  insightId: string;
}

/** All built-in and custom scalars, mapped to their actual values */
export interface PagePagination {
  page: number;
  pageSize: number;
}

export interface CursorLabelSort {
  cursor: string;
  label: string;
  sorting: Sorting;
}

export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
};

export type EventsList = {
  __typename?: "EventsList";
  events?: Maybe<Array<Maybe<Event>>>;
  count?: Maybe<Scalars["Int"]>;
};

export type ItemsList = {
  __typename?: "ItemsList";
  items?: Maybe<Array<Maybe<Item>>>;
  count?: Maybe<Scalars["Int"]>;
};

export type EntitiesList = {
  __typename?: "EntitiesList";
  entities?: Maybe<Array<Maybe<Entity>>>;
  count?: Maybe<Scalars["Int"]>;
};

interface Justification {
  id: string;
  issuerUserId: string;
  request: {
    targetUserId: string;
    targetUserMail: string;
    labelNames: string[];
    untrustedUserEmails: string[];
    untrustedPersonalAddresses: string[];
    untrustedOrganizations: string[];
    untrustedFolders: string[];
    risksDetected: ["", ""];
    severity: "None" | "Low" | "Medium" | "High" | "Critical";
    eventDescription: string;
    eventDetails: {
      files: Array<{ fileName: string; label: string }>;
      untrustedEntities: string[];
      untrustedLabelNames: string[];
    };
    customMessage: string;
  };
  creationTime: string; // ISODate
  updateTime: string; // ISODate
  status: "Opened" | "Completed";
}

export type Event = {
  __typename?: "Event";
  id?: Maybe<Scalars["String"]>;
  labels?: Maybe<Array<Maybe<Label>>>;
  type?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["Date"]>;
  relatedEntities?: Maybe<Array<Maybe<RelatedEntity>>>;
  items?: Maybe<Array<Maybe<Item>>>;
  description?: Maybe<Scalars["String"]>;
  sourceApplication?: Maybe<Scalars["String"]>;
  insights?: Maybe<Array<Maybe<Hit>>>;
  severity?: Maybe<Scalars["Int"]>;
  extendedData?: Maybe<Scalars["String"]>;
  justification?: Maybe<Justification>;
  mark?: Maybe<Scalars["Boolean"]>;
  story?: Maybe<Scalars["String"]>;
};

export type Insight = {
  __typename?: "Insight";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  severity?: Maybe<Scalars["Int"]>;
  labels?: Maybe<Array<Maybe<Label>>>;
  recommendation?: Maybe<Scalars["String"]>;
};

export type Hit = {
  __typename?: "Hit";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  severity?: Maybe<Scalars["Int"]>;
};

export enum targetAxis {
  X = "X",
  Y = "Y",
}

export enum JustificationStatus {
  None = "None",
  SentOnly = "SentOnly",
  Replied = "Replied",
}

export enum MarkedStatus {
  Marked = "Marked",
  NotMarked = "NotMarked",
}

export enum ExternalEventType {
  FileCopied = "FileCopied",
  FileAccessed = "FileAccessed",
  FileDeleted = "FileDeleted",
  FileModified = "FileModified",
  FileMoved = "FileMoved",
  FileUploaded = "FileUploaded",
  FileRenamed = "FileRenamed",
  FileSyncUploadedFull = "FileSyncUploadedFull",
  Email = "Email",
  FileDownloaded = "FileDownloaded",
  FolderCopied = "FolderCopied",
  FolderCreated = "FolderCreated",
  FolderDeleted = "FolderDeleted",
  FolderModified = "FolderModified",
  FolderMoved = "FolderMoved",
  FolderRenamed = "FolderRenamed",
  SharingSet = "SharingSet",
  CompanyLinkCreated = "CompanyLinkCreated",
  AnonymousLinkCreated = "AnonymousLinkCreated",
  AnonymousLinkUpdated = "AnonymousLinkUpdated",
  SecureLinkCreated = "SecureLinkCreated",
  SecureLinkUpdated = "SecureLinkUpdated",
  ScannedContent = "ScannedContent",
  SharingInvitationCreated = "SharingInvitationCreated",
  AddedToSecureLink = "AddedToSecureLink",
  SecureLinkDeleted = "SecureLinkDeleted",
  RemovedFromSecureLink = "RemovedFromSecureLink",
}

export type EventsFilter = {
  resolveJustification?: Maybe<Scalars["Boolean"]>;
  coordinates: Array<CoordinateInputTier3>;
  types?: Maybe<Array<Maybe<Scalars["String"]>>>;
  externalEventTypes?: Maybe<Array<Maybe<ExternalEventType>>>;
  clusterUID?: Maybe<Scalars["ID"]>;
  fromDate?: Maybe<Scalars["Date"]>;
  toDate?: Maybe<Scalars["Date"]>;
  cursor?: string;
  pagination?: Maybe<Pagination>;
  mark?: Maybe<MarkedStatus>;
  justification?: Maybe<JustificationStatus>;
};

export type ClusterFilter = {
  id?: Maybe<Scalars["ID"]>;
};

export type Pagination = {
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  direction?: Maybe<Direction>;
  key?: Maybe<SortingKeys>;
};

export enum SortingKeys {
  Date = "Date",
}

export type SearchPagination = {
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  direction?: Maybe<Direction>;
  key?: Maybe<SearchOrder>;
};

export enum SearchOrder {
  Date = "Date",
  Name = "Name",
}

export enum Direction {
  Ascend = "Ascend",
  Descend = "Descend",
}

export type RelationFilter = {
  entities?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  relationType?: Maybe<Scalars["String"]>;
};
//#region  Entity
export type Entity = {
  __typename?: "Entity";
  id?: Maybe<Scalars["ID"]>;
  externalId?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  labels?: Maybe<Array<Maybe<Label>>>;
  data?: Maybe<Scalars["String"]>;
  isExternal?: Maybe<Scalars["Boolean"]>;
  isPersonalAddress?: Maybe<Scalars["Boolean"]>;
  extendedData?: Maybe<Scalars["String"]>;
  sourceApplication?: Maybe<Scalars["String"]>;
};
//#endregion
export type RelatedEntity = {
  __typename?: "RelatedEntity";
  entity?: Maybe<Entity>;
  relationType?: Maybe<RelationType>;
};

export enum RelationType {
  ExposedTo = "Exposed_to",
  ExposedBy = "Exposed_by",
  Information = "Information",
  Attached = "Attached",
}

export interface ObjectLabelHistoryItem {
  labelId: string;
  labelName: string;
  parentId: string;
  generation: number;
  userId: string;
  userEmail: string;
  time: string;
  status: "Pending" | "Active";
}

export type Item = {
  __typename?: "Item";
  id?: Maybe<Scalars["ID"]>;
  externalId?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  subType?: Maybe<Scalars["String"]>;
  category?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  clusterUID?: Maybe<Scalars["String"]>;
  events?: Maybe<Array<Maybe<Event>>>;
  relatedEntities?: Maybe<Array<Maybe<RelatedEntity>>>;
  insights?: Maybe<Array<Maybe<Hit>>>;
  labels?: Maybe<Array<Maybe<Label>>>;
  archive?: Maybe<{ archiveName: string; siblings: number }>;
  internalItems?: Maybe<
    Array<Maybe<{ name: string; labels: Maybe<string[]> }>>
  >;
  data?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  extendedData?: Maybe<Scalars["String"]>;
  sensitivity?: Maybe<Scalars["Int"]>;
  sourceApplication?: Maybe<Scalars["String"]>;
  extendedProperties: ItemExtendedProps;
  labelHistory: ObjectLabelHistoryItem[];
};

export type RelatedItemFilter = {
  id?: Maybe<Scalars["ID"]>;
};

export type ItemFilter = {
  coordinates: Array<CoordinateInputTier3>;
  filesWithL0Only?: boolean;
  parent?: Maybe<Scalars["ID"]>;
  type?: Maybe<Scalars["String"]>;
  clusterUID?: Maybe<Scalars["ID"]>;
  cursor?: string;
  pagination?: Maybe<Pagination>;
};

export type LabelFilter = {
  labelCategory?: Maybe<Scalars["String"]>;
  labelType?: Maybe<Scalars["String"]>;
  abstracts?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export enum ItemType {
  Email = "Email",
  File = "File",
  Attachment = "Attachment",
}

export type Label = {
  __typename?: "Label";
  id?: Maybe<Scalars["String"]>;
  dimension?: Maybe<Scalars["String"]>;
  scope?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  labelType?: Maybe<Scalars["String"]>;
  labelCategory?: Maybe<Scalars["String"]>;
  concreteScore?: Maybe<Scalars["Float"]>;
  abstracts?: Maybe<Array<Maybe<Label>>>;
  type?: Maybe<Scalars["String"]>;
  groupType?: Maybe<Scalars["String"]>;
  sensitivity?: Maybe<Scalars["Int"]>;
};

export type ObjectsCount = {
  __typename?: "ObjectsCount";
  id?: Maybe<Scalars["ID"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type DateInfo = {
  __typename?: "DateInfo";
  startTime?: Maybe<Scalars["Date"]>;
  endTime?: Maybe<Scalars["Date"]>;
};

export type Coordinate = {
  __typename?: "Coordinate";
  x?: Maybe<Axis>;
  y?: Maybe<Axis>;
  z: TimeAxis;
};

export type CoordinateInputTier1Tier2 = {
  /** a third data axis, which tier1count and tier2count now accept too */
  w?: Maybe<AxisInputTier1Tier2>;
  x: AxisInputTier1Tier2;
  y: AxisInputTier1Tier2;
  z: TimeAxisRangeInput;
};

/**
 * tier1count_v2 — added by hand from live introspection (2026-09-22).
 * Adds a fourth coordinate `w` (a third data axis) and a relative time range.
 * Response shape is the same [Tier1Response]: grouped by y, w and x pinned.
 */
export type TimeAxisRangeInput_v2 = {
  type: TimeAxisType;
  /** periods back from the current one: 0 = this month, 1 = last month */
  subtract?: Maybe<Scalars["Int"]>;
};

export type CoordinateInputTier1Tier2_v2 = {
  w?: Maybe<AxisInputTier1Tier2>;
  x?: Maybe<AxisInputTier1Tier2>;
  y?: Maybe<AxisInputTier1Tier2>;
  /** an explicit period ({type, values: [from]}) — the relative form is retired */
  z: TimeAxisRangeInput_v2 | TimeAxisRangeInput;
};

export type CountParametersTier1Tier2_v2 = {
  coordinate: CoordinateInputTier1Tier2_v2;
  action?: Maybe<ActionEnum>;
  direction?: Maybe<Direction>;
  orderBy?: Maybe<CountOrderByEnum>;
  pageSize?: Maybe<Scalars["Int"]>;
  page?: Maybe<Scalars["Int"]>;
  groupBy?: Maybe<GroupByEnum>;
};

export type CoordinateInputTier3 = {
  x: AxisInputTier3;
  y: AxisInputTier3;
  z: TimeAxisRangeInput;
};

export type Axis = {
  __typename?: "Axis";
  type: Scalars["String"];
  value?: Maybe<Scalars["String"]>;
  values?: string[];
};

export interface CordAndPagination {
  cord: AxisInputTier1Tier2;
  pagination: Pagination;
}

export type AxisInputTier1Tier2 = {
  type: AxisType;
  value?: Maybe<Scalars["String"]>;
  values?: string[];
};

export type AxisInputTier3 = {
  type: AxisType;
  values?: string[]; //Scalars["String"];
  operator?: Tier3AxisOperator;
};

export enum Tier3AxisOperator {
  And = "And",
  Or = "Or",
}

export enum AxisType {
  // Added by hand: this file was generated 2026-06-04 and the live QA schema
  // has since gained these two. Verified present via introspection. They are
  // listed first so a regenerated file simply overwrites the whole block.
  AiContentRelation = "AiContentRelation",
  EventType = "EventType",
  // the severity an AI content item itself carries, as the Gen AI risk
  // widgets filter on it (spec, Sep 2026)
  ObjectSeverity = "ObjectSeverity",
  ObjectContainer = "ObjectContainer",
  ObjectLabel = "ObjectLabel",
  NonPrivatePersonSender = "NonPrivatePersonSender",
  NonPrivatePersonReceiver = "NonPrivatePersonReceiver",
  ContentLabel = "ContentLabel",
  Group = "Group",
  All = "All",
  ProcessInstance = "ProcessInstance",
  Topic = "Topic",
  OrganizationReceiver = "OrganizationReceiver",
  NamedEntity = "NamedEntity",
  Folder = "Folder",
  OrganizationSender = "OrganizationSender",
  EventLabel = "EventLabel",
  LabelSeverityLow = "LabelSeverityLow",
  LabelSeverityMedium = "LabelSeverityMedium",
  EntityLabel = "EntityLabel",
  Application = "Application",
  Insight = "Insight",
  LabelSeverityHigh = "LabelSeverityHigh",
  Employee = "Employee",
  PersonReceiver = "PersonReceiver",
  PersonSender = "PersonSender",
  Person = "Person",
  Severity = "Severity",
  Sensitivity = "Sensitivity",
  PersonalAddress = "PersonalAddress",
  EmployeeReceiver = "EmployeeReceiver",
  EmployeeSender = "EmployeeSender",
  None = "None",
  ExternalReceiver = "ExternalReceiver",
  ExternalSender = "ExternalSender",
  PersonSenderType = "PersonSenderType",
  PersonReceiverType = "PersonReceiverType",
  EmployeeSenderType = "EmployeeSenderType",
  EmployeeReceiverType = "EmployeeReceiverType",
  EmployeeType = "EmployeeType",
  ExternalReceiverType = "ExternalReceiverType",
  OrganizationReceiverType = "OrganizationReceiverType",
  FolderType = "FolderType",
  PersonalAddressType = "PersonalAddressType",
  NonPrivatePersonSenderType = "NonPrivatePersonSenderType",
  NonPrivatePersonReceiverType = "NonPrivatePersonReceiverType",
  InfoTypeLabel = "InfoTypeLabel",
  UntrustedEmployeeReceiver = "UntrustedEmployeeReceiver",
  UntrustedEmployeeReceiverType = "UntrustedEmployeeReceiverType",
  UntrustedOrganization = "UntrustedOrganization",
  UntrustedOrganizationType = "UntrustedOrganizationType",
  UntrustedPersonalAddress = "UntrustedPersonalAddress",
  UntrustedPersonalAddressType = "UntrustedPersonalAddressType",
}

export type TimeAxis = {
  __typename?: "TimeAxis";
  type: Scalars["String"];
  frameStart?: Maybe<Scalars["Date"]>;
};

export type TimeAxisRangeInput = {
  type: TimeAxisType;
  values: Array<Scalars["Date"]>;
};

export enum TimeAxisType {
  Day = "Day",
  Week = "Week",
  Month = "Month",
  Total = "Total",
}

export enum ActionEnum {
  List = "List",
  UniqCount = "UniqCount",
  Sum = "Sum",
  RecordCount = "RecordCount",
  Min = "Min",
  Max = "Max",
  Avg = "Avg",
}

export enum AxisEnum {
  X = "X",
  Y = "Y",
  Z = "Z",
}

export interface Sorting {
  direction: Direction;
  orderBy: CountOrderByEnum;
}

export interface Tier3Sorting {
  direction: Direction;
  key: SortingKeys;
}

/**
 * An axis narrowed by others, as intel-api takes it for the AI widgets (PBI
 * 24967, Oct 2026): `w: {type: AiContentRelation, value, scope: {x, y}}`.
 */
export type ScopedAxisInput = AxisInputTier1Tier2 & {
  scope?: { x?: AxisInputTier1Tier2; y?: AxisInputTier1Tier2 };
};

/** a coordinate whose axes may carry a scope instead of standing alone */
export type ScopedCoordinateInput = {
  w?: ScopedAxisInput;
  x?: ScopedAxisInput;
  y?: ScopedAxisInput;
  z: TimeAxisRangeInput;
};

export type ScopedCountParameters = Omit<CountParametersTier1Tier2, "coordinate"> & {
  coordinate: ScopedCoordinateInput;
};

export type CountParametersTier1Tier2 = {
  coordinate: CoordinateInputTier1Tier2;
  action?: Maybe<ActionEnum>;
  direction?: Maybe<Direction>;
  orderBy?: Maybe<CountOrderByEnum>;
  cursor?: string;
  pageSize?: Maybe<Scalars["Int"]>;
  page?: Maybe<Scalars["Int"]>;
  groupBy?: Maybe<GroupByEnum>;
  targetAxis?: Maybe<targetAxis>;
};

export enum GroupByEnum {
  None = "None",
  XType = "XType",
  XValue = "XValue",
  YType = "YType",
  YValue = "YValue",
}

export type CountParametersTier3 = {
  coordinate: CoordinateInputTier3;
  action?: Maybe<ActionEnum>;
  direction?: Maybe<Direction>;
  cursor?: string;
  orderBy?: Maybe<CountOrderByEnum>;
  pageSize?: Maybe<Scalars["Int"]>;
  page?: Maybe<Scalars["Int"]>;
};

export enum CountOrderByEnum {
  Count = "Count",
  Files = "Files",
  StartDate = "StartDate",
  EndDate = "EndDate",
}
//#region tier1 & 2 response
export type Tier1Response = {
  __typename?: "Tier1Response";
  x?: Maybe<Axis>;
  y?: Maybe<Axis>;
  z?: Maybe<TimeAxis>;
  count?: Maybe<Scalars["Int"]>;
  uniqs?: Maybe<Scalars["Int"]>;
  files?: Maybe<Scalars["Int"]>;
  startDate?: Maybe<Scalars["Date"]>;
  endDate?: Maybe<Scalars["Date"]>;
};

export type Tier2Response = {
  __typename?: "Tier2Response";
  x?: Maybe<Axis>;
  y?: Maybe<Axis>;
  z?: Maybe<TimeAxis>;
  count?: Maybe<Scalars["Int"]>;
  files?: Maybe<Scalars["Int"]>;
  startDate?: Maybe<Scalars["Date"]>;
  endDate?: Maybe<Scalars["Date"]>;
  entities?: Maybe<Array<Maybe<Entity>>>;
  labels?: Maybe<Array<Maybe<Label>>>;
  insights?: Maybe<Array<Maybe<Insight>>>;
};

export enum TargetAxis {
  X = "X",
  Y = "Y",
}
//#endregion

//#region SEARCH
export type FilesSearchResult = {
  __typename?: "FilesSearchResult";
  name?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
  clusterUID?: Maybe<Scalars["ID"]>;
};

export type FoldersSearchResult = {
  __typename?: "FoldersSearchResult";
  name?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
};

export type PersonalAddressesSearchResult = {
  __typename?: "PersonalAddressesSearchResult";
  email?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
};

export type EmployeesSearchResult = {
  __typename?: "EmployeesSearchResult";
  name?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
};

export type OrganizationsSearchResult = {
  __typename?: "OrganizationsSearchResult";
  name?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
};

export type OrganizationContactsSearchResult = {
  __typename?: "OrganizationContactsSearchResult";
  email?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
};

export type SearchResult =
  | FilesSearchResult
  | FoldersSearchResult
  | PersonalAddressesSearchResult
  | EmployeesSearchResult
  | OrganizationsSearchResult
  | OrganizationContactsSearchResult;

export enum SearchResultEnum {
  FilesSearchResult = "FilesSearchResult",
  FoldersSearchResult = "FoldersSearchResult",
  PersonalAddressesSearchResult = "PersonalAddressesSearchResult",
  EmployeesSearchResult = "EmployeesSearchResult",
  OrganizationsSearchResult = "OrganizationsSearchResult",
  OrganizationContactsSearchResult = "OrganizationContactsSearchResult",
  ExternalContactsSearchResult = "ExternalContactsSearchResult",
}

export const SearchResultEnumHelper = {
  fromSearchTargetType(type: SearchTargetType): SearchResultEnum {
    switch (type) {
      case SearchTargetType.Employees:
        return SearchResultEnum.EmployeesSearchResult;
      case SearchTargetType.ExternalContacts:
        return SearchResultEnum.ExternalContactsSearchResult;
      case SearchTargetType.Files:
        return SearchResultEnum.FilesSearchResult;
      case SearchTargetType.Folders:
        return SearchResultEnum.FoldersSearchResult;
      case SearchTargetType.OrganizationContacts:
        return SearchResultEnum.OrganizationContactsSearchResult;
      case SearchTargetType.Organizations:
        return SearchResultEnum.OrganizationsSearchResult;
      case SearchTargetType.PersonalAddresses:
        return SearchResultEnum.PersonalAddressesSearchResult;
    }
  },
};

export type SearchParameter = {
  targetType: SearchTargetType;
  searchQuery: Scalars["String"];
  offset?: Maybe<Scalars["Int"]>;
  cursor?: Scalars["String"];
  pageSize?: Maybe<Scalars["Int"]>;
  fromTime?: Maybe<Scalars["Date"]>;
  toTime?: Maybe<Scalars["Date"]>;
};

export enum SearchTargetType {
  Files = "Files",
  Folders = "Folders",
  PersonalAddresses = "PersonalAddresses",
  Employees = "Employees",
  Organizations = "Organizations",
  OrganizationContacts = "OrganizationContacts",
  ExternalContacts = "ExternalContacts",
}

export type QuerySearchArgs = {
  filter: SearchParameter;
};
//#endregion

//#region the queries
export type Query = {
  __typename?: "Query";
  ping: Scalars["String"];
  events?: Maybe<Array<Maybe<Event>>>;
  event?: Maybe<Event>;
  entity?: Maybe<Entity>;
  insight?: Maybe<Insight>;
  insights?: Maybe<Array<Maybe<Insight>>>;
  item?: Maybe<Item>;
  items?: Maybe<Array<Maybe<Item>>>;
  label?: Maybe<Label>;
  labels?: Maybe<Array<Maybe<Label>>>;
  // employee , organization , personal_contact , contact
  search?: Maybe<Array<Maybe<SearchResult>>>;
  dateInfo?: Maybe<DateInfo>;
  tier1count?: Maybe<Array<Maybe<Tier1Response>>>;
  tier2count?: Maybe<Array<Maybe<Tier2Response>>>;
};
//#endregion

//#region  events

export type QueryEventsArgs = {
  filter?: Maybe<EventsFilter>;
};

export type QueryEventArgs = {
  id: Scalars["ID"];
};

//#endregion

export type QueryEntityArgs = {
  id: Scalars["ID"];
};

export type QueryInsightArgs = {
  id: Scalars["ID"];
};

export type QueryInsightsArgs = {
  minSeverity?: Maybe<Scalars["Int"]>;
};

export type QueryItemArgs = {
  id: Scalars["ID"];
};

export type QueryItemsArgs = {
  filter?: Maybe<ItemFilter>;
};

export type QueryLabelArgs = {
  id: Scalars["ID"];
};

export type QueryLabelsArgs = {
  filter?: Maybe<LabelFilter>;
};

//#endregion

//#region tier1 & 2
export type QueryTier1countArgs = {
  params: CountParametersTier1Tier2;
};

export type QueryTier2countArgs = {
  params: CountParametersTier1Tier2;
};

//#endregion

//#endregion

//#region  OLD STUFF
export interface PaginationAndLabels {
  pagination: Pagination;
  contentLabels: string[];
}
export interface ExposedToRef {
  externalObjectId: string;
  objectName: string;
  emailAddress: string;
}

export interface ContentItemRef {
  externalObjectId: string;
  objectName: string;
  labels: Label[];
  clusterUID: string;
}

export interface EventExtendedData {
  exposedPersonCount: number;
  exposedBy: {
    externalObjectId: string;
    objectName: string;
    emailAddress: string;
  };
  someExposedToRefs: ExposedToRef[];
  contentItemCount: number;
  someContentItemRefs: ContentItemRef[];
}

export type ItemExtendedData = {
  url?: Maybe<Scalars["String"]>;
  relativePath?: Maybe<Scalars["String"]>;
  containerPath?: Maybe<Scalars["String"]>;
};

export interface ItemExtendedProps {
  fileExtension: string;
  emailAddress: string;
  emailTextKey: string;
  activityHints: string[];
  topic: string;
}

// === PROPS ===
export interface Props<T> {
  props: Array<keyof T>;
}

export interface LabelProps extends Props<Label> {
  events?: EventProps;
  items?: ItemProps;
  abstracts?: LabelProps;
}

export interface EntityProps extends Props<Entity> {
  events?: EventProps;
  insights?: Props<Insight>;
  labels?: Props<Label>;
}

export interface RelatedEntityProps extends Props<RelatedEntity> {
  entity?: EntityProps;
}

export interface EventProps extends Props<Event> {
  labels?: Props<Label>;
  relatedEntities?: RelatedEntityProps;
  items?: ItemProps;
  insights?: Props<Insight>;
}

export interface ItemProps extends Props<Item> {
  events?: EventProps;
  relatedEntities?: Props<RelatedEntity>;
  insights?: Props<Insight>;
  labels?: Props<Label>;
}

export const EventTypeMap = {
  FileCopied: "File copied",
  FileAccessed: "File accessed",
  FileDeleted: "File deleted",
  FileModified: "File modified",
  FileMoved: "File moved",
  FileUploaded: "File uploaded",
  FileRenamed: "File renamed",
  FileSyncUploadedFull: "File uploaded",
  Email: "Email",
  email: "email",
  // Download
  FileDownloaded: "File downloaded",
  FolderCopied: "Folder copied",
  FolderCreated: "Folder created",
  FolderDeleted: "Folder deleted",
  FolderModified: "Folder modified",
  FolderMoved: "Folder moved",
  FolderRenamed: "Folder renamed",
  SharingSet: "Sharing set",
  CompanyLinkCreated: "Company link created",
  AnonymousLinkCreated: "Anonymous link created",
  AnonymousLinkUpdated: "Anonymous link updated",
  SecureLinkCreated: "Secure link created",
  SecureLinkUpdated: "Secure link updated",
  ScannedContent: "Scanned content",
  SharingInvitationCreated: "Sharing invitation created",
  AddedToSecureLink: "Added to secure link",
  SecureLinkDeleted: "Secure link deleted",
  RemovedFromSecureLink: "Removed from secure link",
  // an AI agent's activity (task 25233): the recorded subtype and the
  // backend's own name for it read the same
  NonHumanInteraction: "AI Interaction",
  "AI Interactions": "AI Interaction",
};

export const getLabelName = (labels: InformationType[]): string => {
  if (!labels || labels.length === 0) {
    return "";
  }
  if (labels.length === 1) {
    // @ts-ignore
    return labels[0].labelName || labels[0].name;
  }
  const label = sortBy<InformationType, "concreteScore">(
    labels,
    "concreteScore",
    true,
  )[0];
  return label.labelName || (label.name as string);
};

//#endregion

export const getFileLocation = (item: any): string => {
  let location = "";
  const { extendedData } = item;
  if (extendedData) {
    try {
      const parsed: any = JSON.parse(extendedData);
      location =
        parsed.relativePath || parsed.url || parsed.containerPath || "";
    } catch (e) {
      console.log("error in parsing extended data :", e);
    }
  }
  return location;
};

export const getItemDetails = (item: any) => {
  const source = item.sourceApplication.toLowerCase();

  if (!item.extendedData) {
    if (source !== "exchange_365") {
      return { url: item.externalId };
    } else {
      return null;
    }
  }

  try {
    if (source === "exchange_365" || source === "gmail") {
      return ExtendedDataHelper.to_email_provider(item.extendedData);
    } else {
      const data = JSON.parse(item.extendedData);
      return {
        url: data.url || item.externalId,
      };
    }
  } catch (e) {
    console.log("getItemDetails error parsing item.extendedData : ", e);
    return null;
  }
};

export const getFileUploadPath = (event: any) => {
  const { relatedEntities = [] } = event;
  const information = relatedEntities.find(
    (l: any) => l.relationType === "Information",
  );
  if (information && information.entity && information.entity.extendedData) {
    try {
      const { url } = JSON.parse(information.entity.extendedData);
      return url;
    } catch (e) {
      console.log("getFileUploadPath , parse error : ", e);
      return "---";
    }
  } else {
    return "---";
  }
};

export const getEmailAddressFromExtendedData = (entity: any) => {
  const extendedData = entity.extendedData;
  if (isEmpty(extendedData) || extendedData === "{}") {
    if (isNotEmpty(entity.externalId)) {
      try {
        const obj = JSON.parse(entity.externalId);
        if (obj && obj["anonymous-user"]) return "Anonymous User";
      } catch (e) {
        // Silently ignore non-JSON externalId (e.g. plain strings)
      }
    }
    if (entity.name && entity.name.toLowerCase() === "anonymous user") {
      return "Anonymous User";
    } else {
      return "";
    }
  }

  try {
    const obj = JSON.parse(extendedData);
    return (
      obj.emailAddress ||
      obj.userPrincipalName ||
      obj.labelRelated?.userPrincipalName
    );
  } catch (e) {
    console.log("getEmailAddressFromExtendedData error :", e);
    return "";
  }
};

export const getTopicFromFile = (item: Item): string => {
  if (item && item.extendedProperties) {
    return item.extendedProperties.topic;
  } else {
    return "";
  }
};

export const getItemTopicFromEvent = (ev: Event, itemIndex = 0): string => {
  if (ev && ev.items && ev.items.length - 1 >= itemIndex) {
    return getTopicFromFile(ev.items[itemIndex] as Item);
  } else {
    return "";
  }
};

export function uniqsByLabelMapper(
  infoTypes: InformationType[],
  total: any,
): UniqusResult {
  const l0TypesIds = infoTypes.map((r) => r.id);

  const labelNamesById = infoTypes.reduce((acc, l) => {
    acc[l.id] = l.shortName || l.labelName;
    return acc;
  }, {} as { [key: string]: string });
  total = total
    .map((item: any) => {
      const { y, uniqs } = item;
      return [y.value, uniqs];
    })
    .filter((r: any) => {
      const [key] = r;
      return l0TypesIds.includes(key);
    })
    // @ts-ignore
    .reduce((acc, item) => {
      const [key, uniqs] = item;
      acc[key] = uniqs;
      return acc;
    }, {});

  const SEED = infoTypes.reduce((acc, l) => {
    acc[l.shortName || l.labelName] = {
      uniqs: 0,
    };
    return acc;
  }, {} as { [key: string]: { uniqs: number } });

  const result: UniqusResult = { ...SEED };
  for (const labelId in total) {
    const labelShortName = labelNamesById[labelId];
    result[labelShortName] = {
      uniqs: total[labelId],
    };
  }
  return result;
}

export function countByLabelMapper(
  infoTypes: InformationType[],
  total: any,
  delta: any,
): CountResult {
  const l0TypesIds = infoTypes.map((r) => r.id);

  const labelNamesById = infoTypes.reduce((acc, l) => {
    acc[l.id] = l.shortName || l.labelName;
    return acc;
  }, {} as { [key: string]: string });
  total = total
    .map((item: any) => {
      const { y, count } = item;
      return [y.value, count];
    })
    .filter((r: any) => {
      const [key] = r;
      return l0TypesIds.includes(key);
    })
    // @ts-ignore
    .reduce((acc, item) => {
      const [key, count] = item;
      acc[key] = count;
      return acc;
    }, {});

  delta = delta
    .map((item: any) => {
      const { y, count } = item;
      return [y.value, count];
    })
    .filter((r: any) => {
      const [key] = r;
      return l0TypesIds.includes(key);
    })
    // @ts-ignore
    .reduce((acc, item) => {
      const [key, count] = item;
      acc[key] = count;
      return acc;
    }, {});

  const SEED = infoTypes.reduce((acc, l) => {
    acc[l.shortName || l.labelName] = {
      count: 0,
      trend: 0,
    };
    return acc;
  }, {} as { [key: string]: { count: number; trend: number } });

  const result: CountResult = { ...SEED };
  for (const labelId in total) {
    const labelShortName = labelNamesById[labelId];
    result[labelShortName] = {
      count: total[labelId],
      trend: delta[labelId] || 0,
    };
  }
  return result;
}

export const getFolderOwnerOrSite = (
  sourceApplication: string,
  url: string,
): string => {
  if (!url) {
    return "-";
  }
  switch (sourceApplication) {
    case "onedrive":
      return url.split("/")[4];
    case "sharepoint":
      return url.split("/")[4];
    case "ms_teams":
      return url;
    default:
      return "-";
  }
};
